// eslint-disable-next-line import/prefer-default-export
export function setLocale(locale) {
    return { locale, type: 'SELECT_LOCALE' };
}
